import { render, staticRenderFns } from "./TabsCom.vue?vue&type=template&id=090af46b&scoped=true"
import script from "./TabsCom.vue?vue&type=script&lang=js"
export * from "./TabsCom.vue?vue&type=script&lang=js"
import style0 from "./TabsCom.vue?vue&type=style&index=0&id=090af46b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090af46b",
  null
  
)

export default component.exports